"use strict";
exports.__esModule = true;
exports.getProcessingFee = exports.calculateProcessingFee = void 0;
var calculateProcessingFee = function (rent, percentage) {
    return rent * (percentage / 100);
};
exports.calculateProcessingFee = calculateProcessingFee;
var getProcessingFee = function (processingFee, monthlyRent) {
    if (processingFee && monthlyRent) {
        return (0, exports.calculateProcessingFee)(monthlyRent.amount, processingFee);
    }
    return 0;
};
exports.getProcessingFee = getProcessingFee;
